import React from 'react';
import TagsGridActions from './TagsGridActions';

const tagsGridColumns = [
    {
        id: 'id',
        Header: 'Id',
        accessor: 'id',
        width: 70,
    },
    {
        Header: 'Tag Name',
        accessor: 'term',
        sortable: false,
    },
    {
        id: 'vocabularyId',
        Header: 'Vocabularies',
        accessor: 'vocabulary_id',
        sortable: false,
        show: false,
    },
    {
        Header: 'level',
        accessor: 'level',
        sortable: false,
        show: false,
    },
    {
        Header: 'Actions',
        width: 100,
        sortable: false,

        Cell: (props) => <TagsGridActions props={props} />,
    },
];

export default tagsGridColumns;



// WEBPACK FOOTER //
// ./src/containers/tags/TagsGridColumns.jsx